/*
 * Public API Surface of inova-core
 */

export * from './inova-pipes.module'
export * from './safe-html.pipe'
export * from './user-language.pipe'
export * from './linkify.pipe'
export * from './whatsapp-text.pipe'


